import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';

import Tabs from "./Tabs";
import TabPane from "./TabPane";
//我的课程
import CourseManageMyCourses from "./CourseManageMyCourses";
//我的答疑
import CourseManageMyQuestions from "./CourseManageMyQuestions";
//我的评价
import CourseManageMyComment from "./CourseManageMyComment";
//收藏课程
import CourseManageMyCollect from "./CourseManageMyCollect";
export class CourseManage extends Component {
  state = {
    defaultActiveKey: 0,
  }
  static propTypes = {
    center: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  componentWillMount() {
    //路由绑定
    let { pathname } = this.props.history.location;
    pathname = pathname.slice(pathname.lastIndexOf('/') + 1, pathname.length);
    this.setState({
      defaultActiveKey: parseInt(pathname, 10),
    })
  }
  componentDidMount() {
    //路由监听
    this.props.history.listen((res) => {
      let path = res.pathname.split('/')[3];
      this.setState({
        defaultActiveKey: parseInt(path, 10),
      })
    })
  }
  updateRouter(activeKey) {
    this.props.history.replace(`/center/courseManage/${activeKey}`)
  }
  render() {
    const { defaultActiveKey } = this.state;
    return (
      <div className="center-course-manage">
        <div className="tabs">
          <Tabs
            {...this.props}
            defaultActiveKey={defaultActiveKey}
            onTabsChange={(activeKey) => {
              this.setState({
                defaultActiveKey: activeKey
              });
              this.updateRouter(activeKey);
            }}
            tabs={[{ Name: "我的课程" }, { Name: "我的答疑" }, { Name: "我的评价" }, { Name: "收藏课程" }]}
          />
        </div>
        <TabPane {...this.props} defaultActiveKey={defaultActiveKey}>
          <CourseManageMyCourses {...this.props} />
          <CourseManageMyQuestions {...this.props} />
          <CourseManageMyComment {...this.props} />
          <CourseManageMyCollect {...this.props} />
        </TabPane>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    center: state.center,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CourseManage);



// WEBPACK FOOTER //
// ./src/features/center/CourseManage.js